// Generated by scripts/gen-api-facade.mjs — do not edit.
import { useAccessListRolesHook, useAccessEnterMemberViewHook, useAccessLeaveMemberViewHook, useAccessSetMainAppAdminVisibilityHook, useAccessGetAssignmentsHook, useAccessGrantAccessHook, useAccessRevokeAccessHook, useAccessGetEffectiveAccessHook, useAccessGetAccessAuditHook } from './generated/access';
import { useAccountSwitchingGetOtherAccountsHook, useAccountSwitchingDeleteOtherAccountHook, useAccountSwitchingSwitchAccountHook, useAccountSwitchingSoftLogoutHook } from './generated/account-switching';
import { useAhGetStatsHook, useAhGetListingsHook, useAhGetListingHook, useAhGetSnapshotsHook, useAhTriggerScanHook, useAhPlaceBidHook, useAhGetBidsHook } from './generated/ah';
import { useAhWatchListHook, useAhWatchCreateHook, useAhWatchGetHook, useAhWatchUpdateHook, useAhWatchDeleteHook, useAhWatchCreateRuleHook, useAhWatchUpdateRuleHook, useAhWatchDeleteRuleHook, useAhWatchRulePreviewHook, useAhWatchWizardDiffHook, useAhWatchApplyRulesHook, useAhWatchMatchesHook } from './generated/ah-watch';
import { useAlertsAdminListRulesHook, useAlertsAdminCreateRuleHook, useAlertsAdminUpdateRuleHook, useAlertsAdminDeleteRuleHook, useAlertsAdminListEventsHook, useAlertsAdminCurrentMetricsHook, useAlertsAdminGetPreferencesHook, useAlertsAdminSetPreferencesHook, useAlertsAdminSendTestHook } from './generated/alerts-admin';
import { useApiKeyListHook, useApiKeyCreateHook, useApiKeyDeleteHook } from './generated/api-key';
import { useAppEventViewGetHook, useAppEventViewGetInTimeRangeHook, useAppEventViewGetWhereHook, useAppEventViewGetByTypeHook, useAppEventViewGetPerformanceDataHook, useAppEventViewGetPerformanceDataAllTimeHook, useAppEventViewGetAllLoggedLocationsHook } from './generated/app-event-view';
import { useBiomeObservationGetMineHook, useBiomeObservationCreateHook, useBiomeObservationDeleteAllMineHook, useBiomeObservationGetRunsHook, useBiomeObservationDeleteHook, useBiomeObservationExportHook } from './generated/biome-observation';
import { useBotAuditLogGetAuditLogHook, useBotAuditLogGetDisconnectsHook, useBotAuditLogExportDisconnectsHook } from './generated/bot-audit-log';
import { useBotAuthInitiateAuthHook, useBotAuthAuthStatusHook, useBotAuthToggleKeepaliveHook, useBotAuthForceRefreshAuthHook, useBotAuthRevokeAuthHook } from './generated/bot-auth';
import { useBotGroupListBotGroupsHook, useBotGroupCreateBotGroupHook, useBotGroupUpdateBotGroupHook, useBotGroupDeleteBotGroupHook } from './generated/bot-group';
import { useBotLicenseMeHook, useBotLicenseForBotHook, useBotLicenseAttachHook, useBotLicenseDetachHook, useBotLicenseAdminUserSeatsHook, useBotLicenseAdminRevokeHook, useBotLicenseAdminClearCooldownHook } from './generated/bot-license';
import { useBotLifecycleStartBotHook, useBotLifecycleGetResumeConfigHook, useBotLifecycleSetResumeConfigHook, useBotLifecycleStopBotHook, useBotLifecycleRestartBotHook, useBotLifecycleSendCommandHook, useBotLifecycleGetStatusHook, useBotLifecycleGetChatLogHook, useBotLifecycleGetConsoleLogHook, useBotLifecycleGetPlayerStateHook, useBotLifecycleGetInventoryHook, useBotLifecycleGetEntitiesHook, useBotLifecycleDropInventorySlotHook, useBotLifecycleCloseInventoryWindowHook, useBotLifecycleMoveInventorySlotHook, useBotLifecycleClickInventorySlotHook } from './generated/bot-lifecycle';
import { useBotMsgGetContactsHook, useBotMsgGetConversationHook, useBotMsgSendHook, useBotMsgMarkReadHook, useBotMsgGetNotificationPrefHook, useBotMsgSetNotificationPrefHook } from './generated/bot-msg';
import { useBotPluginListPluginsHook, useBotPluginEnablePluginHook, useBotPluginDisablePluginHook, useBotPluginGetPluginSettingsHook, useBotPluginSavePluginSettingsHook, useBotPluginResetPluginSettingsHook } from './generated/bot-plugin';
import { useBotPluginOverviewGetOverviewHook } from './generated/bot-plugin-overview';
import { useBotProfileGetProfileHook, useBotProfileGetNameCooldownHook, useBotProfileCheckNameAvailableHook, useBotProfileSetSkinFromUrlHook, useBotProfileSetSkinFromFileHook, useBotProfileResetSkinHook, useBotProfileSetCapeHook, useBotProfileHideCapeHook, useBotProfileChangeNameHook } from './generated/bot-profile';
import { useBotRegistryListBotsHook, useBotRegistryListAllBotsForAdminHook, useBotRegistryGetBotHook, useBotRegistryDeleteBotRegistryHook, useBotRegistrySetVotingHook, useBotRegistryGetChatLogHook, useBotRegistrySearchChatLogHook, useBotRegistryCopySettingsHook, useBotRegistryLinkNewBotHook, useBotRegistryLinkNewBedrockBotHook, useBotRegistryGetProxyAssignmentHook, useBotRegistrySetProxyHook, useBotRegistrySetExternalProxyHook } from './generated/bot-registry';
import { useBotSelfShutdownListOpenHook, useBotSelfShutdownListForBotHook, useBotSelfShutdownGetReportHook, useBotSelfShutdownAcknowledgeHook } from './generated/bot-self-shutdown';
import { useBotStatsGetStatsHook, useBotStatsGetSystemQueueHistoryHook, useBotStatsGetHistoryHook, useBotStatsGetAutoResumeStatusHook, useBotStatsGetShutdownStatusHook } from './generated/bot-stats';
import { useBotTaskGetAvailableTasksHook, useBotTaskGetParameterOptionsHook, useBotTaskRunTaskHook, useBotTaskEnqueueTaskHook, useBotTaskCancelTaskHook, useBotTaskPauseTaskHook, useBotTaskResumeTaskHook, useBotTaskGetTaskStatusHook, useBotTaskGetTaskHistoryHook, useBotTaskCancelQueuedTaskHook, useBotTaskExportTaskTranscriptHook } from './generated/bot-task';
import { useBotshopDomainsAdminGetDomainsHook, useBotshopDomainsAdminCreateDomainHook, useBotshopDomainsAdminUpdateDomainHook, useBotshopDomainsAdminDeleteDomainHook, useBotshopDomainsAdminGetShopsHook, useBotshopDomainsAdminAssignShopHook } from './generated/botshop-domains-admin';
import { useCaseOpeningGetCaseOpeningAccountHook, useCaseOpeningScanCasesHook, useCaseOpeningOpenCasesHook, useCaseOpeningStopCaseOpeningHook } from './generated/case-opening';
import { useCaseOpeningAdminGetCaseWinStatsHook } from './generated/case-opening-admin';
import { useChangelogGetDescriptionHook, useChangelogGetVersionsHook, useChangelogPostChangelogHook } from './generated/changelog';
import { useCitybuildStatusListStatusesHook, useCitybuildStatusResetStatusHook } from './generated/citybuild-status';
import { useCommandGetCommandsToExecuteHook, useCommandExecuteCommandHook, useCommandOutstandingCommandsHook } from './generated/command';
import { useCompressedPlacementAdminGetBlockedItemsHook, useCompressedPlacementAdminSetBlockedItemsHook } from './generated/compressed-placement-admin';
import { useCropFarmerGetCropFieldsHook, useCropFarmerCreateCropFieldHook, useCropFarmerUpdateCropFieldHook, useCropFarmerDeleteCropFieldHook, useCropFarmerScanCropFieldHook, useCropFarmerCreateCropHarvestConfigHook, useCropFarmerUpdateCropHarvestConfigHook, useCropFarmerDeleteCropHarvestConfigHook, useCropFarmerRunCropHarvestConfigHook, useCropFarmerCreateCropPlantConfigHook, useCropFarmerUpdateCropPlantConfigHook, useCropFarmerDeleteCropPlantConfigHook, useCropFarmerRunCropPlantConfigHook, useCropFarmerStopCropFarmerHook } from './generated/crop-farmer';
import { useDemolishGetDemolishConfigsHook, useDemolishCreateDemolishConfigHook, useDemolishUpdateDemolishConfigHook, useDemolishDeleteDemolishConfigHook, useDemolishRunDemolishConfigHook, useDemolishStopDemolishHook } from './generated/demolish';
import { useEventHandlerCatalogHook, useEventHandlerListHook, useEventHandlerCreateHook, useEventHandlerUpdateHook, useEventHandlerDeleteHook, useEventHandlerDryRunHook, useEventHandlerExecutionsHook } from './generated/event-handler';
import { useFarmGetFarmConfigsHook, useFarmCreateFarmConfigHook, useFarmUpdateFarmConfigHook, useFarmDeleteFarmConfigHook, useFarmRunFarmConfigHook, useFarmGetFarmRecordingsHook, useFarmExportFarmRecordingHook, useFarmStopFarmHook } from './generated/farm';
import { useFarmHelperGetConfigHook, useFarmHelperUpsertConfigHook, useFarmHelperRunHook, useFarmHelperStopHook } from './generated/farm-helper';
import { useFeatureFlagsGetMyFlagsHook } from './generated/feature-flags';
import { useFeatureFlagsAdminGetCatalogHook, useFeatureFlagsAdminListOverridesHook, useFeatureFlagsAdminSetOverrideHook, useFeatureFlagsAdminRemoveOverrideHook } from './generated/feature-flags-admin';
import { useGogglesInfoHook, useGogglesDownloadHook } from './generated/goggles';
import { useGrantedUsersGetConnectionCodeHook, useGrantedUsersActivateConnectionCodeHook, useGrantedUsersCheckCodeHook, useGrantedUsersGrantAccountHook, useGrantedUsersRevokeAccountHook, useGrantedUsersGetGrantedAccountsHook, useGrantedUsersGrantCommandPrefabHook, useGrantedUsersRevokeCommandPrefabHook, useGrantedUsersGetCommandPrefabsHook, useGrantedUsersGetCommandPrefabHook, useGrantedUsersUpdateCommandPrefabHook, useGrantedUsersGetCommandPrefabsForBotHook, useGrantedUsersGetCommandPrefabsInGrantHook, useGrantedUsersCreateCommandPrefabHook, useGrantedUsersDeleteCommandPrefabHook, useGrantedUsersGetMyBotsHook, useGrantedUsersGetNameOfBotHook, useGrantedUsersModifyAccessLevelHook, useGrantedUsersGetAllActiveBotsHook, useGrantedUsersGetGrantedBotsHook } from './generated/granted-users';
import { useGrantsCatalogHook, useGrantsMeHook, useGrantsUserSummaryHook, useGrantsTenantSummaryHook, useGrantsSetTenantPoolHook, useGrantsSetUserDirectHook, useGrantsAssignFromPoolHook, useGrantsRevokeHook } from './generated/grants';
import { useHealthGetHook } from './generated/health';
import { useInventoryGetAllItemsHook, useInventoryGetRecipeHook, useInventoryGetStoragesHook, useInventoryCreateStorageHook, useInventoryGetStorageHook, useInventoryUpdateStorageHook, useInventoryDeleteStorageHook, useInventoryAddChestHook, useInventoryDeleteAllChestsHook, useInventoryGetChestsHook, useInventoryBulkUpdateChestConfigHook, useInventoryDeleteChestHook, useInventoryUpdateChestConfigHook, useInventoryRunReadChestsHook, useInventoryRunScanHook, useInventoryRunReadContentsHook, useInventoryRunReadInfiniteSettingsHook, useInventoryRunSortHook, useInventoryRunLearnChestsHook, useInventoryGetStorageBotsHook, useInventoryAssignStorageBotHook, useInventoryUnassignStorageBotHook, useInventoryGetChestSlotsHook, useInventoryGetStorageItemsHook, useInventorySetStorageItemsHook, useInventoryGetAllStorageItemsHook, useInventoryResolveItemHook, useInventoryResolveBatchHook, useInventoryGetRecipeDetailHook, useInventoryGetPricingHook, useInventorySetPricingHook, useInventoryGetTenantSettingsHook, useInventoryPlanCraftHook, useInventoryCreateCraftRequestHook, useInventoryCancelCraftRequestHook, useInventoryPlanCraftOrderHook, useInventoryCreateCraftOrderHook, useInventoryGetCraftOrdersHook, useInventoryCancelCraftOrderHook, useInventoryCancelCraftOrderLineHook, useInventoryGetStockHook, useInventorySaveStockHook, useInventoryGetPlannedOrdersHook, useInventoryGetExternalDemandHook, useInventoryGetTasksHook, useInventoryGetReservationsHook, useInventoryCancelTaskHook, useInventoryGetCustomItemsHook, useInventoryUpsertCustomItemHook, useInventoryPlanMoveHook, useInventoryCreateMoveRequestHook, useInventoryGetMoveRequestsHook, useInventoryCancelMoveRequestHook } from './generated/inventory';
import { useInventoryAuditGetAuditLogHook, useInventoryAuditCreateManualAuditEntryHook } from './generated/inventory-audit';
import { useInventoryUnloadConfigsGetUnloadAtConfigsHook, useInventoryUnloadConfigsCreateUnloadAtConfigHook, useInventoryUnloadConfigsUpdateUnloadAtConfigHook, useInventoryUnloadConfigsDeleteUnloadAtConfigHook, useInventoryUnloadConfigsRunUnloadAtConfigHook, useInventoryUnloadConfigsGetUnloadAreaConfigsHook, useInventoryUnloadConfigsCreateUnloadAreaConfigHook, useInventoryUnloadConfigsUpdateUnloadAreaConfigHook, useInventoryUnloadConfigsDeleteUnloadAreaConfigHook, useInventoryUnloadConfigsRunUnloadAreaConfigHook, useInventoryUnloadConfigsStopUnloadAreaConfigHook } from './generated/inventory-unload-configs';
import { useItemEntryPostItemEntryHook, useItemEntryPutItemEntryHook, useItemEntryGetItemEntriesHook, useItemEntryDeleteItemEntryHook, useItemEntryGetItemEntryHook, useItemEntryAdjustPriceHook } from './generated/item-entry';
import { useJarDownloadDownloadJarHook, useJarDownloadGetKeyHook, useJarDownloadGetVersionsHook, useJarDownloadGetVersionsReleaseHook, useJarDownloadGetAllClassNamesHook, useJarDownloadTranslateLogHook } from './generated/jar-download';
import { useJobEntryGetAllJobEntriesByNameHook, useJobEntryGetAllJobEntriesHook, useJobEntryTriggerJobScanHook, useJobEntryGetJobEntriesRangeHook } from './generated/job-entry';
import { useKoffermaticInfoHook, useKoffermaticDownloadHook, useKoffermaticPerformanceHook } from './generated/koffermatic';
import { useKoffermaticPerfAdminListHook, useKoffermaticPerfAdminDetailHook, useKoffermaticPerfAdminDeleteHook, useKoffermaticPerfAdminDirectivesHook, useKoffermaticPerfAdminRequestDeepProfileHook, useKoffermaticPerfAdminClearDeepProfileHook, useKoffermaticPerfAdminDownloadHook } from './generated/koffermatic-perf-admin';
import { useMapCacheListHook, useMapCacheGetImageHook } from './generated/map-cache';
import { useMinecraftConfigGetAllDropConfigsHook, useMinecraftConfigGetDropConfigHook, useMinecraftConfigDeleteDropConfigHook, useMinecraftConfigCreateDropConfigHook, useMinecraftConfigUpdateDropConfigHook } from './generated/minecraft-config';
import { useMinecraftUsernameTrackerListHook, useMinecraftUsernameTrackerAddHook, useMinecraftUsernameTrackerRemoveHook } from './generated/minecraft-username-tracker';
import { useMsgContactMuteGetMutedContactsHook, useMsgContactMuteMuteContactHook, useMsgContactMuteUnmuteContactHook } from './generated/msg-contact-mute';
import { useNotificationListHook, useNotificationReadAllHook, useNotificationDismissHook, useNotificationDismissAllHook } from './generated/notification';
import { useOAuthGetClientNameHook, useOAuthGetClientsHook, useOAuthRegenerateClientSecretHook, useOAuthGetClientHook, useOAuthDeleteClientHook, useOAuthCreateClientHook, useOAuthUpdateClientHook, useOAuthGetRedirectUrisHook, useOAuthAddRedirectUriHook, useOAuthRemoveRedirectUriHook } from './generated/oauth';
import { useOnlinePlayersGetDomainsHook, useOnlinePlayersSearchKnownHook, useOnlinePlayersGetDomainHook, useOnlinePlayersGetPlayerHistoryHook } from './generated/online-players';
import { useOrbsTraderGetOrbShopCatalogHook, useOrbsTraderGetOrbsTraderConfigsHook, useOrbsTraderCreateOrbsTraderConfigHook, useOrbsTraderUpdateOrbsTraderConfigHook, useOrbsTraderDeleteOrbsTraderConfigHook, useOrbsTraderRunOrbsTraderConfigHook, useOrbsTraderStopOrbsTraderHook } from './generated/orbs-trader';
import { usePacketRecordingAdminStartHook, usePacketRecordingAdminStopHook, usePacketRecordingAdminDeleteHook, usePacketRecordingAdminListHook, usePacketRecordingAdminListRecordableBotsHook, usePacketRecordingAdminDownloadHook } from './generated/packet-recording-admin';
import { usePaymentsLedgerHook, usePaymentsSummaryHook, usePaymentsEntryHook, usePaymentsSetNoteHook, usePaymentsResolveHook, usePaymentsScheduledHook, usePaymentsCreateScheduledHook, usePaymentsPreviewScheduledHook, usePaymentsUpdateScheduledHook, usePaymentsCancelScheduledHook, usePaymentsPauseScheduledHook, usePaymentsResumeScheduledHook, usePaymentsSkipScheduledHook, usePaymentsPayScheduledNowHook } from './generated/payments';
import { usePlayerBlacklistAdminListEntriesHook, usePlayerBlacklistAdminCreateEntryHook, usePlayerBlacklistAdminUpdateEntryHook, usePlayerBlacklistAdminDeleteEntryHook } from './generated/player-blacklist-admin';
import { usePlayerListListPlayerListsHook, usePlayerListCreatePlayerListHook, usePlayerListRenamePlayerListHook, usePlayerListDeletePlayerListHook, usePlayerListGetEntriesHook, usePlayerListAddEntryHook, usePlayerListRemoveEntryHook, usePlayerListSetEntryNoteHook, usePlayerListExportEntriesHook, usePlayerListImportEntriesHook, usePlayerListSearchHook } from './generated/player-list';
import { usePlayerProfileGetByNameHook, usePlayerProfileGetByUuidHook } from './generated/player-profile';
import { usePlotAclGetConfigHook, usePlotAclUpsertConfigHook, usePlotAclSetActiveHook, usePlotAclGetActivityHook, usePlotAclGetBansHook, usePlotAclAddBanHook, usePlotAclRemoveBanHook, usePlotAclSetBanNoteHook, usePlotAclGetWhitelistHook, usePlotAclAddWhitelistHook, usePlotAclRemoveWhitelistHook, usePlotAclSetWhitelistNoteHook, usePlotAclAddRankExemptionHook, usePlotAclRemoveRankExemptionHook, usePlotAclSetRankExemptionNoteHook, usePlotAclGetOverviewHook, usePlotAclAttachWhitelistListHook, usePlotAclDetachWhitelistListHook, usePlotAclAttachBanListHook, usePlotAclDetachBanListHook, usePlotAclAttachRankExemptionListHook, usePlotAclDetachRankExemptionListHook, usePlotAclAttachAccessListHook, usePlotAclDetachAccessListHook, usePlotAclUpdatePlotSettingsHook, usePlotAclAddPlotAccessHook, usePlotAclRemovePlotAccessHook, usePlotAclSetPlotAccessNoteHook, usePlotAclRemovePlotHook } from './generated/plot-acl';
import { usePokeballGetPokeballConfigsHook, usePokeballCreatePokeballConfigHook, usePokeballUpdatePokeballConfigHook, usePokeballDeletePokeballConfigHook, usePokeballRunPokeballConfigHook, usePokeballStopPokeballHook } from './generated/pokeball';
import { useProfileInfoGetLatestHook, useProfileInfoGetHistoryHook } from './generated/profile-info';
import { useProxyGetAllHook, useProxyCreateHook, useProxyGetDirectInfoHook, useProxyGetExternalHook, useProxyGetBotsHook, useProxyReassignBotHook, useProxyGetHealthHook, useProxyGetHook, useProxyUpdateHook, useProxyDeleteHook, useProxyGetPoolsHook, useProxyCreatePoolHook, useProxyUpdatePoolHook, useProxyDeletePoolHook, useProxySyncPoolHook, useProxyTestPoolHook } from './generated/proxy';
import { usePushGetConfigHook, usePushSubscribeHook, usePushUnsubscribeHook, usePushGetPreferencesHook, usePushSetPreferencesHook, usePushSendTestHook } from './generated/push';
import { useReconnectWindowsAdminListWindowsHook, useReconnectWindowsAdminCreateWindowHook, useReconnectWindowsAdminGetStatusHook, useReconnectWindowsAdminUpdateWindowHook, useReconnectWindowsAdminDeleteWindowHook } from './generated/reconnect-windows-admin';
import { useRepairGetRepairConfigsHook, useRepairCreateRepairConfigHook, useRepairUpdateRepairConfigHook, useRepairDeleteRepairConfigHook, useRepairRunRepairConfigHook, useRepairStopRepairHook } from './generated/repair';
import { useSchematicLicenseChallengeHook, useSchematicLicenseSubmitChallengeHook } from './generated/schematic-license';
import { useSchematicLicenseAdminListEntriesHook, useSchematicLicenseAdminCreateEntryHook, useSchematicLicenseAdminUpdateEntryHook, useSchematicLicenseAdminDeleteEntryHook } from './generated/schematic-license-admin';
import { useSchematicsListHook, useSchematicsGetBuildPlanHook, useSchematicsSetBuildSiteHook, useSchematicsDeleteHook } from './generated/schematics';
import { useSeedCrackAddStructuresHook, useSeedCrackGetWorldsHook, useSeedCrackGetWorldHook, useSeedCrackClearWorldHook, useSeedCrackDeepCrackHook, useSeedCrackDeleteFortressHook, useSeedCrackGetMapTileHook, useSeedCrackGetMapFeaturesHook } from './generated/seed-crack';
import { useSellbotGetConfigHook, useSellbotUpsertConfigHook, useSellbotSetEnabledHook, useSellbotSetActiveHook, useSellbotSetAnkaufEnabledHook, useSellbotSetQuoteEnabledHook, useSellbotSetPriceQueryEnabledHook, useSellbotSetPublishToGrieferUtilsHook, useSellbotSetPublishToGrieferInfoHook, useSellbotCreateOfferHook, useSellbotDeleteOfferHook, useSellbotCreateOfferFolderHook, useSellbotRenameOfferFolderHook, useSellbotDeleteOfferFolderHook, useSellbotMoveOfferTreeItemHook, useSellbotUpdateOfferNoteHook, useSellbotUpdateOfferStockCacheHook, useSellbotUpdateOfferUnlistedHook, useSellbotUpdateOfferCompressedListingHook, useSellbotExportOffersHook, useSellbotImportOffersHook, useSellbotCreateTierHook, useSellbotUpdateTierHook, useSellbotDeleteTierHook, useSellbotRenameBundleHook, useSellbotRulePreviewHook, useSellbotCreateRuleHook, useSellbotApplyRulesHook, useSellbotWizardDiffHook, useSellbotUpdateRuleHook, useSellbotDeleteRuleHook, useSellbotGetTransactionsHook, useSellbotGetTransactionHook, useSellbotSearchCustomersHook, useSellbotGetActivityHook, useSellbotGetJournalHook, useSellbotGetOverviewHook, useSellbotGetStatsHook, useSellbotExportStatsHook, useSellbotGetChamberStockHook, useSellbotRescanHook, useSellbotScanStockHook, useSellbotGetSelfTestStepsHook, useSellbotRunSelfTestHook, useSellbotCaptureHomeHook, useSellbotRecordZoneDropPathHook, useSellbotUpsertAnkaufTierHook, useSellbotDeleteAnkaufTierHook, useSellbotCreateAnkaufPriceStageHook, useSellbotUpdateAnkaufPriceStageHook, useSellbotDeleteAnkaufPriceStageHook, useSellbotCreateLimitHook, useSellbotUpdateLimitHook, useSellbotDeleteLimitHook, useSellbotGetAnkaufTransactionsHook } from './generated/sellbot';
import { useSellbotGrantListHook, useSellbotGrantCreateHook, useSellbotGrantRedemptionsHook, useSellbotGrantUpdateHook, useSellbotGrantDeleteHook, useSellbotGrantRevokeHook } from './generated/sellbot-grant';
import { useSellbotHologramListHook, useSellbotHologramCreateHook, useSellbotHologramLiveHook, useSellbotHologramRefreshLiveHook, useSellbotHologramBindingsHook, useSellbotHologramUpdateHook, useSellbotHologramDeleteHook, useSellbotHologramExclusionsHook, useSellbotHologramAddExcludedPlayerHook, useSellbotHologramRemoveExcludedPlayerHook, useSellbotHologramAttachExcludedListHook, useSellbotHologramDetachExcludedListHook, useSellbotHologramRenderHook } from './generated/sellbot-hologram';
import { useSellbotSkullTextureUploadHook, useSellbotSkullTextureGetHook } from './generated/sellbot-skull-texture';
import { useSetupModeArmHook, useSetupModeCancelHook, useSetupModePendingHook } from './generated/setup-mode';
import { useShopStockListBotsHook, useShopStockAddBotHook, useShopStockGetSnapshotHook, useShopStockGetBotHook, useShopStockUpdateBotHook, useShopStockDeleteBotHook, useShopStockRefetchBotHook, useShopStockGetWatchlistHook, useShopStockAddWatchHook, useShopStockRemoveWatchHook, useShopStockCompareItemHook, useShopStockGetItemsHook } from './generated/shop-stock';
import { useSpawnerUpgradeGetSpawnerUpgradeConfigsHook, useSpawnerUpgradeCreateSpawnerUpgradeConfigHook, useSpawnerUpgradeGetKnownSpawnersHook, useSpawnerUpgradeUpdateSpawnerUpgradeConfigHook, useSpawnerUpgradeDeleteSpawnerUpgradeConfigHook, useSpawnerUpgradeRunSpawnerUpgradeConfigHook, useSpawnerUpgradeStopSpawnerUpgradeHook } from './generated/spawner-upgrade';
import { useSurveillanceGetSessionsHook, useSurveillanceDownloadSessionHook, useSurveillanceDeleteSessionHook, useSurveillanceGetEventsHook, useSurveillanceClearEventsHook } from './generated/surveillance';
import { useTaskFailureCapsuleAdminListHook, useTaskFailureCapsuleAdminGetHook, useTaskFailureCapsuleAdminDeleteHook, useTaskFailureCapsuleAdminStatusHook, useTaskFailureCapsuleAdminCaptureHook, useTaskFailureCapsuleAdminDownloadHook } from './generated/task-failure-capsule-admin';
import { useTenantGetTenantHook, useTenantGetSettingsHook, useTenantUpdateSettingsHook, useTenantGetMembersHook, useTenantAddMemberHook, useTenantRemoveMemberHook, useTenantUpdateMemberRoleHook, useTenantLeaveTenantHook } from './generated/tenant';
import { useTenantAdminGetAllTenantsHook, useTenantAdminCreateTenantHook, useTenantAdminGetTenantHook, useTenantAdminUpdateTenantHook, useTenantAdminDeleteTenantHook, useTenantAdminGetTenantSettingsHook, useTenantAdminUpdateTenantSettingsHook, useTenantAdminGetMembersHook, useTenantAdminAddMemberHook, useTenantAdminRemoveMemberHook, useTenantAdminUpdateMemberRoleHook } from './generated/tenant-admin';
import { useTenantCreateCreateTenantHook } from './generated/tenant-create';
import { useUserLoginHook, useUserMySessionHook, useUserRegisterHook, useUserChangePasswordHook, useUserUpdateHook, useUserGetUserHook, useUserLogoutHook, useUserUsersHook, useUserSessionsGet1Hook, useUserLogoutUserGlobalHook, useUserGetUserIdFromUUIDHook, useUserChatLogsPostHook, useUserChatLogsGetHook, useUserAuditLogHook, useUserGetGrantsForUserHook, useUserGrantClientHook, useUserRevokeGrantHook, useUserGetMyTenantHook, useUserGetUserByIdHook, useUserDeleteHook, useUserChangePasswordAdminHook, useUserSessionsGet2Hook, useUserSessionHook, useUserAuditLogAdminHook, useUserEnabledClassesPostHook, useUserEnabledClassesGetHook, useUserRegenerateAddonKeyHook, useUserSwitchAllClassesHook } from './generated/user';
import { useVektorAdminListPossessionsHook, useVektorAdminPossessionStatsHook, useVektorAdminKickHook, useVektorAdminStartDiagnosticsHook, useVektorAdminStopDiagnosticsHook, useVektorAdminDiagnosticsStatusHook, useVektorAdminExportDiagnosticsHook, useVektorAdminStartMonitorHook, useVektorAdminStopMonitorHook, useVektorAdminListMonitorsHook, useVektorAdminListMonitorableBotsHook, useVektorAdminExportMonitorHook } from './generated/vektor-admin';
import { useVektorGogglesHandshakeHook, useVektorGogglesHandshakeDevHook, useVektorGogglesMeHook, useVektorGogglesListBotsHook, useVektorGogglesListOverlaysHook, useVektorGogglesStreamOverlaysHook, useVektorGogglesKickPossessorHook, useVektorGogglesListStorageChestIndexHook, useVektorGogglesListStorageChestContentsHook, useVektorGogglesRecordObservedChestHook, useVektorGogglesSubmitSchematicHook, useVektorGogglesListSchematicsHook } from './generated/vektor-goggles';
import { useVektorUtilsInfoHook, useVektorUtilsDownloadHook } from './generated/vektor-utils';
import { useVillageObservationGetMineHook, useVillageObservationDeleteAllMineHook, useVillageObservationGetRunsHook, useVillageObservationExportHook } from './generated/village-observation';
import { useVillagerTradingGetVillagerHallsHook, useVillagerTradingCreateVillagerHallHook, useVillagerTradingGetHallVillagersHook, useVillagerTradingUpdateVillagerHallHook, useVillagerTradingDeleteVillagerHallHook, useVillagerTradingScanVillagerHallHook, useVillagerTradingCreateVillagerTradeConfigHook, useVillagerTradingUpdateVillagerTradeConfigHook, useVillagerTradingDeleteVillagerTradeConfigHook, useVillagerTradingRunVillagerTradeConfigHook, useVillagerTradingStopVillagerTradingHook } from './generated/villager-trading';
import { useVotingGetSitesHook, useVotingGetStateHook, useVotingGetLogHook, useVotingAvailabilityHook, useVotingMyAdHocHook, useVotingCreateMyAdHocHook, useVotingDeleteMyAdHocByUsernameHook, useVotingRunHook, useVotingPreviewHook, useVotingSchedulerStatusHook, useVotingAdHocListHook, useVotingAdHocCreateHook, useVotingAdHocDeleteHook, useVotingAdHocSetEnabledHook, useVotingRunTickHook, useVotingAdminTodayHook, useVotingAdminStatsHook, useVotingAdminLogHook, useVotingAdminResetFailuresHook, useVotingSetSiteEnabledHook, useVotingAdminClearStaleHook, useVotingAdminProxiesHook, useVotingAdminProxySyncHook, useVotingAdminProxyReplaceHook, useVotingAdminForceStaleHook } from './generated/voting';
import { useWallEPushBotStateHook } from './generated/wall-e';
import { useWebhookListHook, useWebhookCreateHook, useWebhookGetHook, useWebhookUpdateHook, useWebhookDeleteHook, useWebhookSendTestHook } from './generated/webhook';
import { useXDSMGetWeihnachtenHook } from './generated/xdsm';

export type * from './generated/schemas';
export { isOk, type Envelope } from './envelope';

export function useApi() {
    return {
    access: {
        listRoles: useAccessListRolesHook(),
        enterMemberView: useAccessEnterMemberViewHook(),
        leaveMemberView: useAccessLeaveMemberViewHook(),
        setMainAppAdminVisibility: useAccessSetMainAppAdminVisibilityHook(),
        getAssignments: useAccessGetAssignmentsHook(),
        grantAccess: useAccessGrantAccessHook(),
        revokeAccess: useAccessRevokeAccessHook(),
        getEffectiveAccess: useAccessGetEffectiveAccessHook(),
        getAccessAudit: useAccessGetAccessAuditHook(),
    },
    accountSwitching: {
        getOtherAccounts: useAccountSwitchingGetOtherAccountsHook(),
        deleteOtherAccount: useAccountSwitchingDeleteOtherAccountHook(),
        switchAccount: useAccountSwitchingSwitchAccountHook(),
        softLogout: useAccountSwitchingSoftLogoutHook(),
    },
    ah: {
        getStats: useAhGetStatsHook(),
        getListings: useAhGetListingsHook(),
        getListing: useAhGetListingHook(),
        getSnapshots: useAhGetSnapshotsHook(),
        triggerScan: useAhTriggerScanHook(),
        placeBid: useAhPlaceBidHook(),
        getBids: useAhGetBidsHook(),
    },
    ahWatch: {
        list: useAhWatchListHook(),
        create: useAhWatchCreateHook(),
        get: useAhWatchGetHook(),
        update: useAhWatchUpdateHook(),
        delete: useAhWatchDeleteHook(),
        createRule: useAhWatchCreateRuleHook(),
        updateRule: useAhWatchUpdateRuleHook(),
        deleteRule: useAhWatchDeleteRuleHook(),
        rulePreview: useAhWatchRulePreviewHook(),
        wizardDiff: useAhWatchWizardDiffHook(),
        applyRules: useAhWatchApplyRulesHook(),
        matches: useAhWatchMatchesHook(),
    },
    alertsAdmin: {
        listRules: useAlertsAdminListRulesHook(),
        createRule: useAlertsAdminCreateRuleHook(),
        updateRule: useAlertsAdminUpdateRuleHook(),
        deleteRule: useAlertsAdminDeleteRuleHook(),
        listEvents: useAlertsAdminListEventsHook(),
        currentMetrics: useAlertsAdminCurrentMetricsHook(),
        getPreferences: useAlertsAdminGetPreferencesHook(),
        setPreferences: useAlertsAdminSetPreferencesHook(),
        sendTest: useAlertsAdminSendTestHook(),
    },
    apiKey: {
        list: useApiKeyListHook(),
        create: useApiKeyCreateHook(),
        delete: useApiKeyDeleteHook(),
    },
    appEventView: {
        get: useAppEventViewGetHook(),
        getInTimeRange: useAppEventViewGetInTimeRangeHook(),
        getWhere: useAppEventViewGetWhereHook(),
        getByType: useAppEventViewGetByTypeHook(),
        getPerformanceData: useAppEventViewGetPerformanceDataHook(),
        getPerformanceDataAllTime: useAppEventViewGetPerformanceDataAllTimeHook(),
        getAllLoggedLocations: useAppEventViewGetAllLoggedLocationsHook(),
    },
    biomeObservation: {
        getMine: useBiomeObservationGetMineHook(),
        create: useBiomeObservationCreateHook(),
        deleteAllMine: useBiomeObservationDeleteAllMineHook(),
        getRuns: useBiomeObservationGetRunsHook(),
        delete: useBiomeObservationDeleteHook(),
        export: useBiomeObservationExportHook(),
    },
    botAuditLog: {
        getAuditLog: useBotAuditLogGetAuditLogHook(),
        getDisconnects: useBotAuditLogGetDisconnectsHook(),
        exportDisconnects: useBotAuditLogExportDisconnectsHook(),
    },
    botAuth: {
        initiateAuth: useBotAuthInitiateAuthHook(),
        authStatus: useBotAuthAuthStatusHook(),
        toggleKeepalive: useBotAuthToggleKeepaliveHook(),
        forceRefreshAuth: useBotAuthForceRefreshAuthHook(),
        revokeAuth: useBotAuthRevokeAuthHook(),
    },
    botGroup: {
        listBotGroups: useBotGroupListBotGroupsHook(),
        createBotGroup: useBotGroupCreateBotGroupHook(),
        updateBotGroup: useBotGroupUpdateBotGroupHook(),
        deleteBotGroup: useBotGroupDeleteBotGroupHook(),
    },
    botLicense: {
        me: useBotLicenseMeHook(),
        forBot: useBotLicenseForBotHook(),
        attach: useBotLicenseAttachHook(),
        detach: useBotLicenseDetachHook(),
        adminUserSeats: useBotLicenseAdminUserSeatsHook(),
        adminRevoke: useBotLicenseAdminRevokeHook(),
        adminClearCooldown: useBotLicenseAdminClearCooldownHook(),
    },
    botLifecycle: {
        startBot: useBotLifecycleStartBotHook(),
        getResumeConfig: useBotLifecycleGetResumeConfigHook(),
        setResumeConfig: useBotLifecycleSetResumeConfigHook(),
        stopBot: useBotLifecycleStopBotHook(),
        restartBot: useBotLifecycleRestartBotHook(),
        sendCommand: useBotLifecycleSendCommandHook(),
        getStatus: useBotLifecycleGetStatusHook(),
        getChatLog: useBotLifecycleGetChatLogHook(),
        getConsoleLog: useBotLifecycleGetConsoleLogHook(),
        getPlayerState: useBotLifecycleGetPlayerStateHook(),
        getInventory: useBotLifecycleGetInventoryHook(),
        getEntities: useBotLifecycleGetEntitiesHook(),
        dropInventorySlot: useBotLifecycleDropInventorySlotHook(),
        closeInventoryWindow: useBotLifecycleCloseInventoryWindowHook(),
        moveInventorySlot: useBotLifecycleMoveInventorySlotHook(),
        clickInventorySlot: useBotLifecycleClickInventorySlotHook(),
    },
    botMsg: {
        getContacts: useBotMsgGetContactsHook(),
        getConversation: useBotMsgGetConversationHook(),
        send: useBotMsgSendHook(),
        markRead: useBotMsgMarkReadHook(),
        getNotificationPref: useBotMsgGetNotificationPrefHook(),
        setNotificationPref: useBotMsgSetNotificationPrefHook(),
    },
    botPlugin: {
        listPlugins: useBotPluginListPluginsHook(),
        enablePlugin: useBotPluginEnablePluginHook(),
        disablePlugin: useBotPluginDisablePluginHook(),
        getPluginSettings: useBotPluginGetPluginSettingsHook(),
        savePluginSettings: useBotPluginSavePluginSettingsHook(),
        resetPluginSettings: useBotPluginResetPluginSettingsHook(),
    },
    botPluginOverview: {
        getOverview: useBotPluginOverviewGetOverviewHook(),
    },
    botProfile: {
        getProfile: useBotProfileGetProfileHook(),
        getNameCooldown: useBotProfileGetNameCooldownHook(),
        checkNameAvailable: useBotProfileCheckNameAvailableHook(),
        setSkinFromUrl: useBotProfileSetSkinFromUrlHook(),
        setSkinFromFile: useBotProfileSetSkinFromFileHook(),
        resetSkin: useBotProfileResetSkinHook(),
        setCape: useBotProfileSetCapeHook(),
        hideCape: useBotProfileHideCapeHook(),
        changeName: useBotProfileChangeNameHook(),
    },
    botRegistry: {
        listBots: useBotRegistryListBotsHook(),
        listAllBotsForAdmin: useBotRegistryListAllBotsForAdminHook(),
        getBot: useBotRegistryGetBotHook(),
        deleteBotRegistry: useBotRegistryDeleteBotRegistryHook(),
        setVoting: useBotRegistrySetVotingHook(),
        getChatLog: useBotRegistryGetChatLogHook(),
        searchChatLog: useBotRegistrySearchChatLogHook(),
        copySettings: useBotRegistryCopySettingsHook(),
        linkNewBot: useBotRegistryLinkNewBotHook(),
        linkNewBedrockBot: useBotRegistryLinkNewBedrockBotHook(),
        getProxyAssignment: useBotRegistryGetProxyAssignmentHook(),
        setProxy: useBotRegistrySetProxyHook(),
        setExternalProxy: useBotRegistrySetExternalProxyHook(),
    },
    botSelfShutdown: {
        listOpen: useBotSelfShutdownListOpenHook(),
        listForBot: useBotSelfShutdownListForBotHook(),
        getReport: useBotSelfShutdownGetReportHook(),
        acknowledge: useBotSelfShutdownAcknowledgeHook(),
    },
    botStats: {
        getStats: useBotStatsGetStatsHook(),
        getSystemQueueHistory: useBotStatsGetSystemQueueHistoryHook(),
        getHistory: useBotStatsGetHistoryHook(),
        getAutoResumeStatus: useBotStatsGetAutoResumeStatusHook(),
        getShutdownStatus: useBotStatsGetShutdownStatusHook(),
    },
    botTask: {
        getAvailableTasks: useBotTaskGetAvailableTasksHook(),
        getParameterOptions: useBotTaskGetParameterOptionsHook(),
        runTask: useBotTaskRunTaskHook(),
        enqueueTask: useBotTaskEnqueueTaskHook(),
        cancelTask: useBotTaskCancelTaskHook(),
        pauseTask: useBotTaskPauseTaskHook(),
        resumeTask: useBotTaskResumeTaskHook(),
        getTaskStatus: useBotTaskGetTaskStatusHook(),
        getTaskHistory: useBotTaskGetTaskHistoryHook(),
        cancelQueuedTask: useBotTaskCancelQueuedTaskHook(),
        exportTaskTranscript: useBotTaskExportTaskTranscriptHook(),
    },
    botshopDomainsAdmin: {
        getDomains: useBotshopDomainsAdminGetDomainsHook(),
        createDomain: useBotshopDomainsAdminCreateDomainHook(),
        updateDomain: useBotshopDomainsAdminUpdateDomainHook(),
        deleteDomain: useBotshopDomainsAdminDeleteDomainHook(),
        getShops: useBotshopDomainsAdminGetShopsHook(),
        assignShop: useBotshopDomainsAdminAssignShopHook(),
    },
    caseOpening: {
        getCaseOpeningAccount: useCaseOpeningGetCaseOpeningAccountHook(),
        scanCases: useCaseOpeningScanCasesHook(),
        openCases: useCaseOpeningOpenCasesHook(),
        stopCaseOpening: useCaseOpeningStopCaseOpeningHook(),
    },
    caseOpeningAdmin: {
        getCaseWinStats: useCaseOpeningAdminGetCaseWinStatsHook(),
    },
    changelog: {
        getDescription: useChangelogGetDescriptionHook(),
        getVersions: useChangelogGetVersionsHook(),
        postChangelog: useChangelogPostChangelogHook(),
    },
    citybuildStatus: {
        listStatuses: useCitybuildStatusListStatusesHook(),
        resetStatus: useCitybuildStatusResetStatusHook(),
    },
    command: {
        getCommandsToExecute: useCommandGetCommandsToExecuteHook(),
        executeCommand: useCommandExecuteCommandHook(),
        outstandingCommands: useCommandOutstandingCommandsHook(),
    },
    compressedPlacementAdmin: {
        getBlockedItems: useCompressedPlacementAdminGetBlockedItemsHook(),
        setBlockedItems: useCompressedPlacementAdminSetBlockedItemsHook(),
    },
    cropFarmer: {
        getCropFields: useCropFarmerGetCropFieldsHook(),
        createCropField: useCropFarmerCreateCropFieldHook(),
        updateCropField: useCropFarmerUpdateCropFieldHook(),
        deleteCropField: useCropFarmerDeleteCropFieldHook(),
        scanCropField: useCropFarmerScanCropFieldHook(),
        createCropHarvestConfig: useCropFarmerCreateCropHarvestConfigHook(),
        updateCropHarvestConfig: useCropFarmerUpdateCropHarvestConfigHook(),
        deleteCropHarvestConfig: useCropFarmerDeleteCropHarvestConfigHook(),
        runCropHarvestConfig: useCropFarmerRunCropHarvestConfigHook(),
        createCropPlantConfig: useCropFarmerCreateCropPlantConfigHook(),
        updateCropPlantConfig: useCropFarmerUpdateCropPlantConfigHook(),
        deleteCropPlantConfig: useCropFarmerDeleteCropPlantConfigHook(),
        runCropPlantConfig: useCropFarmerRunCropPlantConfigHook(),
        stopCropFarmer: useCropFarmerStopCropFarmerHook(),
    },
    demolish: {
        getDemolishConfigs: useDemolishGetDemolishConfigsHook(),
        createDemolishConfig: useDemolishCreateDemolishConfigHook(),
        updateDemolishConfig: useDemolishUpdateDemolishConfigHook(),
        deleteDemolishConfig: useDemolishDeleteDemolishConfigHook(),
        runDemolishConfig: useDemolishRunDemolishConfigHook(),
        stopDemolish: useDemolishStopDemolishHook(),
    },
    eventHandler: {
        catalog: useEventHandlerCatalogHook(),
        list: useEventHandlerListHook(),
        create: useEventHandlerCreateHook(),
        update: useEventHandlerUpdateHook(),
        delete: useEventHandlerDeleteHook(),
        dryRun: useEventHandlerDryRunHook(),
        executions: useEventHandlerExecutionsHook(),
    },
    farm: {
        getFarmConfigs: useFarmGetFarmConfigsHook(),
        createFarmConfig: useFarmCreateFarmConfigHook(),
        updateFarmConfig: useFarmUpdateFarmConfigHook(),
        deleteFarmConfig: useFarmDeleteFarmConfigHook(),
        runFarmConfig: useFarmRunFarmConfigHook(),
        getFarmRecordings: useFarmGetFarmRecordingsHook(),
        exportFarmRecording: useFarmExportFarmRecordingHook(),
        stopFarm: useFarmStopFarmHook(),
    },
    farmHelper: {
        getConfig: useFarmHelperGetConfigHook(),
        upsertConfig: useFarmHelperUpsertConfigHook(),
        run: useFarmHelperRunHook(),
        stop: useFarmHelperStopHook(),
    },
    featureFlags: {
        getMyFlags: useFeatureFlagsGetMyFlagsHook(),
    },
    featureFlagsAdmin: {
        getCatalog: useFeatureFlagsAdminGetCatalogHook(),
        listOverrides: useFeatureFlagsAdminListOverridesHook(),
        setOverride: useFeatureFlagsAdminSetOverrideHook(),
        removeOverride: useFeatureFlagsAdminRemoveOverrideHook(),
    },
    goggles: {
        info: useGogglesInfoHook(),
        download: useGogglesDownloadHook(),
    },
    grantedUsers: {
        getConnectionCode: useGrantedUsersGetConnectionCodeHook(),
        activateConnectionCode: useGrantedUsersActivateConnectionCodeHook(),
        checkCode: useGrantedUsersCheckCodeHook(),
        grantAccount: useGrantedUsersGrantAccountHook(),
        revokeAccount: useGrantedUsersRevokeAccountHook(),
        getGrantedAccounts: useGrantedUsersGetGrantedAccountsHook(),
        grantCommandPrefab: useGrantedUsersGrantCommandPrefabHook(),
        revokeCommandPrefab: useGrantedUsersRevokeCommandPrefabHook(),
        getCommandPrefabs: useGrantedUsersGetCommandPrefabsHook(),
        getCommandPrefab: useGrantedUsersGetCommandPrefabHook(),
        updateCommandPrefab: useGrantedUsersUpdateCommandPrefabHook(),
        getCommandPrefabsForBot: useGrantedUsersGetCommandPrefabsForBotHook(),
        getCommandPrefabsInGrant: useGrantedUsersGetCommandPrefabsInGrantHook(),
        createCommandPrefab: useGrantedUsersCreateCommandPrefabHook(),
        deleteCommandPrefab: useGrantedUsersDeleteCommandPrefabHook(),
        getMyBots: useGrantedUsersGetMyBotsHook(),
        getNameOfBot: useGrantedUsersGetNameOfBotHook(),
        modifyAccessLevel: useGrantedUsersModifyAccessLevelHook(),
        getAllActiveBots: useGrantedUsersGetAllActiveBotsHook(),
        getGrantedBots: useGrantedUsersGetGrantedBotsHook(),
    },
    grants: {
        catalog: useGrantsCatalogHook(),
        me: useGrantsMeHook(),
        userSummary: useGrantsUserSummaryHook(),
        tenantSummary: useGrantsTenantSummaryHook(),
        setTenantPool: useGrantsSetTenantPoolHook(),
        setUserDirect: useGrantsSetUserDirectHook(),
        assignFromPool: useGrantsAssignFromPoolHook(),
        revoke: useGrantsRevokeHook(),
    },
    health: {
        get: useHealthGetHook(),
    },
    inventory: {
        getAllItems: useInventoryGetAllItemsHook(),
        getRecipe: useInventoryGetRecipeHook(),
        getStorages: useInventoryGetStoragesHook(),
        createStorage: useInventoryCreateStorageHook(),
        getStorage: useInventoryGetStorageHook(),
        updateStorage: useInventoryUpdateStorageHook(),
        deleteStorage: useInventoryDeleteStorageHook(),
        addChest: useInventoryAddChestHook(),
        deleteAllChests: useInventoryDeleteAllChestsHook(),
        getChests: useInventoryGetChestsHook(),
        bulkUpdateChestConfig: useInventoryBulkUpdateChestConfigHook(),
        deleteChest: useInventoryDeleteChestHook(),
        updateChestConfig: useInventoryUpdateChestConfigHook(),
        runReadChests: useInventoryRunReadChestsHook(),
        runScan: useInventoryRunScanHook(),
        runReadContents: useInventoryRunReadContentsHook(),
        runReadInfiniteSettings: useInventoryRunReadInfiniteSettingsHook(),
        runSort: useInventoryRunSortHook(),
        runLearnChests: useInventoryRunLearnChestsHook(),
        getStorageBots: useInventoryGetStorageBotsHook(),
        assignStorageBot: useInventoryAssignStorageBotHook(),
        unassignStorageBot: useInventoryUnassignStorageBotHook(),
        getChestSlots: useInventoryGetChestSlotsHook(),
        getStorageItems: useInventoryGetStorageItemsHook(),
        setStorageItems: useInventorySetStorageItemsHook(),
        getAllStorageItems: useInventoryGetAllStorageItemsHook(),
        resolveItem: useInventoryResolveItemHook(),
        resolveBatch: useInventoryResolveBatchHook(),
        getRecipeDetail: useInventoryGetRecipeDetailHook(),
        getPricing: useInventoryGetPricingHook(),
        setPricing: useInventorySetPricingHook(),
        getTenantSettings: useInventoryGetTenantSettingsHook(),
        planCraft: useInventoryPlanCraftHook(),
        createCraftRequest: useInventoryCreateCraftRequestHook(),
        cancelCraftRequest: useInventoryCancelCraftRequestHook(),
        planCraftOrder: useInventoryPlanCraftOrderHook(),
        createCraftOrder: useInventoryCreateCraftOrderHook(),
        getCraftOrders: useInventoryGetCraftOrdersHook(),
        cancelCraftOrder: useInventoryCancelCraftOrderHook(),
        cancelCraftOrderLine: useInventoryCancelCraftOrderLineHook(),
        getStock: useInventoryGetStockHook(),
        saveStock: useInventorySaveStockHook(),
        getPlannedOrders: useInventoryGetPlannedOrdersHook(),
        getExternalDemand: useInventoryGetExternalDemandHook(),
        getTasks: useInventoryGetTasksHook(),
        getReservations: useInventoryGetReservationsHook(),
        cancelTask: useInventoryCancelTaskHook(),
        getCustomItems: useInventoryGetCustomItemsHook(),
        upsertCustomItem: useInventoryUpsertCustomItemHook(),
        planMove: useInventoryPlanMoveHook(),
        createMoveRequest: useInventoryCreateMoveRequestHook(),
        getMoveRequests: useInventoryGetMoveRequestsHook(),
        cancelMoveRequest: useInventoryCancelMoveRequestHook(),
    },
    inventoryAudit: {
        getAuditLog: useInventoryAuditGetAuditLogHook(),
        createManualAuditEntry: useInventoryAuditCreateManualAuditEntryHook(),
    },
    inventoryUnloadConfigs: {
        getUnloadAtConfigs: useInventoryUnloadConfigsGetUnloadAtConfigsHook(),
        createUnloadAtConfig: useInventoryUnloadConfigsCreateUnloadAtConfigHook(),
        updateUnloadAtConfig: useInventoryUnloadConfigsUpdateUnloadAtConfigHook(),
        deleteUnloadAtConfig: useInventoryUnloadConfigsDeleteUnloadAtConfigHook(),
        runUnloadAtConfig: useInventoryUnloadConfigsRunUnloadAtConfigHook(),
        getUnloadAreaConfigs: useInventoryUnloadConfigsGetUnloadAreaConfigsHook(),
        createUnloadAreaConfig: useInventoryUnloadConfigsCreateUnloadAreaConfigHook(),
        updateUnloadAreaConfig: useInventoryUnloadConfigsUpdateUnloadAreaConfigHook(),
        deleteUnloadAreaConfig: useInventoryUnloadConfigsDeleteUnloadAreaConfigHook(),
        runUnloadAreaConfig: useInventoryUnloadConfigsRunUnloadAreaConfigHook(),
        stopUnloadAreaConfig: useInventoryUnloadConfigsStopUnloadAreaConfigHook(),
    },
    itemEntry: {
        postItemEntry: useItemEntryPostItemEntryHook(),
        putItemEntry: useItemEntryPutItemEntryHook(),
        getItemEntries: useItemEntryGetItemEntriesHook(),
        deleteItemEntry: useItemEntryDeleteItemEntryHook(),
        getItemEntry: useItemEntryGetItemEntryHook(),
        adjustPrice: useItemEntryAdjustPriceHook(),
    },
    jarDownload: {
        downloadJar: useJarDownloadDownloadJarHook(),
        getKey: useJarDownloadGetKeyHook(),
        getVersions: useJarDownloadGetVersionsHook(),
        getVersionsRelease: useJarDownloadGetVersionsReleaseHook(),
        getAllClassNames: useJarDownloadGetAllClassNamesHook(),
        translateLog: useJarDownloadTranslateLogHook(),
    },
    jobEntry: {
        getAllJobEntriesByName: useJobEntryGetAllJobEntriesByNameHook(),
        getAllJobEntries: useJobEntryGetAllJobEntriesHook(),
        triggerJobScan: useJobEntryTriggerJobScanHook(),
        getJobEntriesRange: useJobEntryGetJobEntriesRangeHook(),
    },
    koffermatic: {
        info: useKoffermaticInfoHook(),
        download: useKoffermaticDownloadHook(),
        performance: useKoffermaticPerformanceHook(),
    },
    koffermaticPerfAdmin: {
        list: useKoffermaticPerfAdminListHook(),
        detail: useKoffermaticPerfAdminDetailHook(),
        delete: useKoffermaticPerfAdminDeleteHook(),
        directives: useKoffermaticPerfAdminDirectivesHook(),
        requestDeepProfile: useKoffermaticPerfAdminRequestDeepProfileHook(),
        clearDeepProfile: useKoffermaticPerfAdminClearDeepProfileHook(),
        download: useKoffermaticPerfAdminDownloadHook(),
    },
    mapCache: {
        list: useMapCacheListHook(),
        getImage: useMapCacheGetImageHook(),
    },
    minecraftConfig: {
        getAllDropConfigs: useMinecraftConfigGetAllDropConfigsHook(),
        getDropConfig: useMinecraftConfigGetDropConfigHook(),
        deleteDropConfig: useMinecraftConfigDeleteDropConfigHook(),
        createDropConfig: useMinecraftConfigCreateDropConfigHook(),
        updateDropConfig: useMinecraftConfigUpdateDropConfigHook(),
    },
    minecraftUsernameTracker: {
        list: useMinecraftUsernameTrackerListHook(),
        add: useMinecraftUsernameTrackerAddHook(),
        remove: useMinecraftUsernameTrackerRemoveHook(),
    },
    msgContactMute: {
        getMutedContacts: useMsgContactMuteGetMutedContactsHook(),
        muteContact: useMsgContactMuteMuteContactHook(),
        unmuteContact: useMsgContactMuteUnmuteContactHook(),
    },
    notification: {
        list: useNotificationListHook(),
        readAll: useNotificationReadAllHook(),
        dismiss: useNotificationDismissHook(),
        dismissAll: useNotificationDismissAllHook(),
    },
    oauth: {
        getClientName: useOAuthGetClientNameHook(),
        getClients: useOAuthGetClientsHook(),
        regenerateClientSecret: useOAuthRegenerateClientSecretHook(),
        getClient: useOAuthGetClientHook(),
        deleteClient: useOAuthDeleteClientHook(),
        createClient: useOAuthCreateClientHook(),
        updateClient: useOAuthUpdateClientHook(),
        getRedirectUris: useOAuthGetRedirectUrisHook(),
        addRedirectUri: useOAuthAddRedirectUriHook(),
        removeRedirectUri: useOAuthRemoveRedirectUriHook(),
    },
    onlinePlayers: {
        getDomains: useOnlinePlayersGetDomainsHook(),
        searchKnown: useOnlinePlayersSearchKnownHook(),
        getDomain: useOnlinePlayersGetDomainHook(),
        getPlayerHistory: useOnlinePlayersGetPlayerHistoryHook(),
    },
    orbsTrader: {
        getOrbShopCatalog: useOrbsTraderGetOrbShopCatalogHook(),
        getOrbsTraderConfigs: useOrbsTraderGetOrbsTraderConfigsHook(),
        createOrbsTraderConfig: useOrbsTraderCreateOrbsTraderConfigHook(),
        updateOrbsTraderConfig: useOrbsTraderUpdateOrbsTraderConfigHook(),
        deleteOrbsTraderConfig: useOrbsTraderDeleteOrbsTraderConfigHook(),
        runOrbsTraderConfig: useOrbsTraderRunOrbsTraderConfigHook(),
        stopOrbsTrader: useOrbsTraderStopOrbsTraderHook(),
    },
    packetRecordingAdmin: {
        start: usePacketRecordingAdminStartHook(),
        stop: usePacketRecordingAdminStopHook(),
        delete: usePacketRecordingAdminDeleteHook(),
        list: usePacketRecordingAdminListHook(),
        listRecordableBots: usePacketRecordingAdminListRecordableBotsHook(),
        download: usePacketRecordingAdminDownloadHook(),
    },
    payments: {
        ledger: usePaymentsLedgerHook(),
        summary: usePaymentsSummaryHook(),
        entry: usePaymentsEntryHook(),
        setNote: usePaymentsSetNoteHook(),
        resolve: usePaymentsResolveHook(),
        scheduled: usePaymentsScheduledHook(),
        createScheduled: usePaymentsCreateScheduledHook(),
        previewScheduled: usePaymentsPreviewScheduledHook(),
        updateScheduled: usePaymentsUpdateScheduledHook(),
        cancelScheduled: usePaymentsCancelScheduledHook(),
        pauseScheduled: usePaymentsPauseScheduledHook(),
        resumeScheduled: usePaymentsResumeScheduledHook(),
        skipScheduled: usePaymentsSkipScheduledHook(),
        payScheduledNow: usePaymentsPayScheduledNowHook(),
    },
    playerBlacklistAdmin: {
        listEntries: usePlayerBlacklistAdminListEntriesHook(),
        createEntry: usePlayerBlacklistAdminCreateEntryHook(),
        updateEntry: usePlayerBlacklistAdminUpdateEntryHook(),
        deleteEntry: usePlayerBlacklistAdminDeleteEntryHook(),
    },
    playerList: {
        listPlayerLists: usePlayerListListPlayerListsHook(),
        createPlayerList: usePlayerListCreatePlayerListHook(),
        renamePlayerList: usePlayerListRenamePlayerListHook(),
        deletePlayerList: usePlayerListDeletePlayerListHook(),
        getEntries: usePlayerListGetEntriesHook(),
        addEntry: usePlayerListAddEntryHook(),
        removeEntry: usePlayerListRemoveEntryHook(),
        setEntryNote: usePlayerListSetEntryNoteHook(),
        exportEntries: usePlayerListExportEntriesHook(),
        importEntries: usePlayerListImportEntriesHook(),
        search: usePlayerListSearchHook(),
    },
    playerProfile: {
        getByName: usePlayerProfileGetByNameHook(),
        getByUuid: usePlayerProfileGetByUuidHook(),
    },
    plotAcl: {
        getConfig: usePlotAclGetConfigHook(),
        upsertConfig: usePlotAclUpsertConfigHook(),
        setActive: usePlotAclSetActiveHook(),
        getActivity: usePlotAclGetActivityHook(),
        getBans: usePlotAclGetBansHook(),
        addBan: usePlotAclAddBanHook(),
        removeBan: usePlotAclRemoveBanHook(),
        setBanNote: usePlotAclSetBanNoteHook(),
        getWhitelist: usePlotAclGetWhitelistHook(),
        addWhitelist: usePlotAclAddWhitelistHook(),
        removeWhitelist: usePlotAclRemoveWhitelistHook(),
        setWhitelistNote: usePlotAclSetWhitelistNoteHook(),
        addRankExemption: usePlotAclAddRankExemptionHook(),
        removeRankExemption: usePlotAclRemoveRankExemptionHook(),
        setRankExemptionNote: usePlotAclSetRankExemptionNoteHook(),
        getOverview: usePlotAclGetOverviewHook(),
        attachWhitelistList: usePlotAclAttachWhitelistListHook(),
        detachWhitelistList: usePlotAclDetachWhitelistListHook(),
        attachBanList: usePlotAclAttachBanListHook(),
        detachBanList: usePlotAclDetachBanListHook(),
        attachRankExemptionList: usePlotAclAttachRankExemptionListHook(),
        detachRankExemptionList: usePlotAclDetachRankExemptionListHook(),
        attachAccessList: usePlotAclAttachAccessListHook(),
        detachAccessList: usePlotAclDetachAccessListHook(),
        updatePlotSettings: usePlotAclUpdatePlotSettingsHook(),
        addPlotAccess: usePlotAclAddPlotAccessHook(),
        removePlotAccess: usePlotAclRemovePlotAccessHook(),
        setPlotAccessNote: usePlotAclSetPlotAccessNoteHook(),
        removePlot: usePlotAclRemovePlotHook(),
    },
    pokeball: {
        getPokeballConfigs: usePokeballGetPokeballConfigsHook(),
        createPokeballConfig: usePokeballCreatePokeballConfigHook(),
        updatePokeballConfig: usePokeballUpdatePokeballConfigHook(),
        deletePokeballConfig: usePokeballDeletePokeballConfigHook(),
        runPokeballConfig: usePokeballRunPokeballConfigHook(),
        stopPokeball: usePokeballStopPokeballHook(),
    },
    profileInfo: {
        getLatest: useProfileInfoGetLatestHook(),
        getHistory: useProfileInfoGetHistoryHook(),
    },
    proxy: {
        getAll: useProxyGetAllHook(),
        create: useProxyCreateHook(),
        getDirectInfo: useProxyGetDirectInfoHook(),
        getExternal: useProxyGetExternalHook(),
        getBots: useProxyGetBotsHook(),
        reassignBot: useProxyReassignBotHook(),
        getHealth: useProxyGetHealthHook(),
        get: useProxyGetHook(),
        update: useProxyUpdateHook(),
        delete: useProxyDeleteHook(),
        getPools: useProxyGetPoolsHook(),
        createPool: useProxyCreatePoolHook(),
        updatePool: useProxyUpdatePoolHook(),
        deletePool: useProxyDeletePoolHook(),
        syncPool: useProxySyncPoolHook(),
        testPool: useProxyTestPoolHook(),
    },
    push: {
        getConfig: usePushGetConfigHook(),
        subscribe: usePushSubscribeHook(),
        unsubscribe: usePushUnsubscribeHook(),
        getPreferences: usePushGetPreferencesHook(),
        setPreferences: usePushSetPreferencesHook(),
        sendTest: usePushSendTestHook(),
    },
    reconnectWindowsAdmin: {
        listWindows: useReconnectWindowsAdminListWindowsHook(),
        createWindow: useReconnectWindowsAdminCreateWindowHook(),
        getStatus: useReconnectWindowsAdminGetStatusHook(),
        updateWindow: useReconnectWindowsAdminUpdateWindowHook(),
        deleteWindow: useReconnectWindowsAdminDeleteWindowHook(),
    },
    repair: {
        getRepairConfigs: useRepairGetRepairConfigsHook(),
        createRepairConfig: useRepairCreateRepairConfigHook(),
        updateRepairConfig: useRepairUpdateRepairConfigHook(),
        deleteRepairConfig: useRepairDeleteRepairConfigHook(),
        runRepairConfig: useRepairRunRepairConfigHook(),
        stopRepair: useRepairStopRepairHook(),
    },
    schematicLicense: {
        challenge: useSchematicLicenseChallengeHook(),
        submitChallenge: useSchematicLicenseSubmitChallengeHook(),
    },
    schematicLicenseAdmin: {
        listEntries: useSchematicLicenseAdminListEntriesHook(),
        createEntry: useSchematicLicenseAdminCreateEntryHook(),
        updateEntry: useSchematicLicenseAdminUpdateEntryHook(),
        deleteEntry: useSchematicLicenseAdminDeleteEntryHook(),
    },
    schematics: {
        list: useSchematicsListHook(),
        getBuildPlan: useSchematicsGetBuildPlanHook(),
        setBuildSite: useSchematicsSetBuildSiteHook(),
        delete: useSchematicsDeleteHook(),
    },
    seedCrack: {
        addStructures: useSeedCrackAddStructuresHook(),
        getWorlds: useSeedCrackGetWorldsHook(),
        getWorld: useSeedCrackGetWorldHook(),
        clearWorld: useSeedCrackClearWorldHook(),
        deepCrack: useSeedCrackDeepCrackHook(),
        deleteFortress: useSeedCrackDeleteFortressHook(),
        getMapTile: useSeedCrackGetMapTileHook(),
        getMapFeatures: useSeedCrackGetMapFeaturesHook(),
    },
    sellbot: {
        getConfig: useSellbotGetConfigHook(),
        upsertConfig: useSellbotUpsertConfigHook(),
        setEnabled: useSellbotSetEnabledHook(),
        setActive: useSellbotSetActiveHook(),
        setAnkaufEnabled: useSellbotSetAnkaufEnabledHook(),
        setQuoteEnabled: useSellbotSetQuoteEnabledHook(),
        setPriceQueryEnabled: useSellbotSetPriceQueryEnabledHook(),
        setPublishToGrieferUtils: useSellbotSetPublishToGrieferUtilsHook(),
        setPublishToGrieferInfo: useSellbotSetPublishToGrieferInfoHook(),
        createOffer: useSellbotCreateOfferHook(),
        deleteOffer: useSellbotDeleteOfferHook(),
        createOfferFolder: useSellbotCreateOfferFolderHook(),
        renameOfferFolder: useSellbotRenameOfferFolderHook(),
        deleteOfferFolder: useSellbotDeleteOfferFolderHook(),
        moveOfferTreeItem: useSellbotMoveOfferTreeItemHook(),
        updateOfferNote: useSellbotUpdateOfferNoteHook(),
        updateOfferStockCache: useSellbotUpdateOfferStockCacheHook(),
        updateOfferUnlisted: useSellbotUpdateOfferUnlistedHook(),
        updateOfferCompressedListing: useSellbotUpdateOfferCompressedListingHook(),
        exportOffers: useSellbotExportOffersHook(),
        importOffers: useSellbotImportOffersHook(),
        createTier: useSellbotCreateTierHook(),
        updateTier: useSellbotUpdateTierHook(),
        deleteTier: useSellbotDeleteTierHook(),
        renameBundle: useSellbotRenameBundleHook(),
        rulePreview: useSellbotRulePreviewHook(),
        createRule: useSellbotCreateRuleHook(),
        applyRules: useSellbotApplyRulesHook(),
        wizardDiff: useSellbotWizardDiffHook(),
        updateRule: useSellbotUpdateRuleHook(),
        deleteRule: useSellbotDeleteRuleHook(),
        getTransactions: useSellbotGetTransactionsHook(),
        getTransaction: useSellbotGetTransactionHook(),
        searchCustomers: useSellbotSearchCustomersHook(),
        getActivity: useSellbotGetActivityHook(),
        getJournal: useSellbotGetJournalHook(),
        getOverview: useSellbotGetOverviewHook(),
        getStats: useSellbotGetStatsHook(),
        exportStats: useSellbotExportStatsHook(),
        getChamberStock: useSellbotGetChamberStockHook(),
        rescan: useSellbotRescanHook(),
        scanStock: useSellbotScanStockHook(),
        getSelfTestSteps: useSellbotGetSelfTestStepsHook(),
        runSelfTest: useSellbotRunSelfTestHook(),
        captureHome: useSellbotCaptureHomeHook(),
        recordZoneDropPath: useSellbotRecordZoneDropPathHook(),
        upsertAnkaufTier: useSellbotUpsertAnkaufTierHook(),
        deleteAnkaufTier: useSellbotDeleteAnkaufTierHook(),
        createAnkaufPriceStage: useSellbotCreateAnkaufPriceStageHook(),
        updateAnkaufPriceStage: useSellbotUpdateAnkaufPriceStageHook(),
        deleteAnkaufPriceStage: useSellbotDeleteAnkaufPriceStageHook(),
        createLimit: useSellbotCreateLimitHook(),
        updateLimit: useSellbotUpdateLimitHook(),
        deleteLimit: useSellbotDeleteLimitHook(),
        getAnkaufTransactions: useSellbotGetAnkaufTransactionsHook(),
    },
    sellbotGrant: {
        list: useSellbotGrantListHook(),
        create: useSellbotGrantCreateHook(),
        redemptions: useSellbotGrantRedemptionsHook(),
        update: useSellbotGrantUpdateHook(),
        delete: useSellbotGrantDeleteHook(),
        revoke: useSellbotGrantRevokeHook(),
    },
    sellbotHologram: {
        list: useSellbotHologramListHook(),
        create: useSellbotHologramCreateHook(),
        live: useSellbotHologramLiveHook(),
        refreshLive: useSellbotHologramRefreshLiveHook(),
        bindings: useSellbotHologramBindingsHook(),
        update: useSellbotHologramUpdateHook(),
        delete: useSellbotHologramDeleteHook(),
        exclusions: useSellbotHologramExclusionsHook(),
        addExcludedPlayer: useSellbotHologramAddExcludedPlayerHook(),
        removeExcludedPlayer: useSellbotHologramRemoveExcludedPlayerHook(),
        attachExcludedList: useSellbotHologramAttachExcludedListHook(),
        detachExcludedList: useSellbotHologramDetachExcludedListHook(),
        render: useSellbotHologramRenderHook(),
    },
    sellbotSkullTexture: {
        upload: useSellbotSkullTextureUploadHook(),
        get: useSellbotSkullTextureGetHook(),
    },
    setupMode: {
        arm: useSetupModeArmHook(),
        cancel: useSetupModeCancelHook(),
        pending: useSetupModePendingHook(),
    },
    shopStock: {
        listBots: useShopStockListBotsHook(),
        addBot: useShopStockAddBotHook(),
        getSnapshot: useShopStockGetSnapshotHook(),
        getBot: useShopStockGetBotHook(),
        updateBot: useShopStockUpdateBotHook(),
        deleteBot: useShopStockDeleteBotHook(),
        refetchBot: useShopStockRefetchBotHook(),
        getWatchlist: useShopStockGetWatchlistHook(),
        addWatch: useShopStockAddWatchHook(),
        removeWatch: useShopStockRemoveWatchHook(),
        compareItem: useShopStockCompareItemHook(),
        getItems: useShopStockGetItemsHook(),
    },
    spawnerUpgrade: {
        getSpawnerUpgradeConfigs: useSpawnerUpgradeGetSpawnerUpgradeConfigsHook(),
        createSpawnerUpgradeConfig: useSpawnerUpgradeCreateSpawnerUpgradeConfigHook(),
        getKnownSpawners: useSpawnerUpgradeGetKnownSpawnersHook(),
        updateSpawnerUpgradeConfig: useSpawnerUpgradeUpdateSpawnerUpgradeConfigHook(),
        deleteSpawnerUpgradeConfig: useSpawnerUpgradeDeleteSpawnerUpgradeConfigHook(),
        runSpawnerUpgradeConfig: useSpawnerUpgradeRunSpawnerUpgradeConfigHook(),
        stopSpawnerUpgrade: useSpawnerUpgradeStopSpawnerUpgradeHook(),
    },
    surveillance: {
        getSessions: useSurveillanceGetSessionsHook(),
        downloadSession: useSurveillanceDownloadSessionHook(),
        deleteSession: useSurveillanceDeleteSessionHook(),
        getEvents: useSurveillanceGetEventsHook(),
        clearEvents: useSurveillanceClearEventsHook(),
    },
    taskFailureCapsuleAdmin: {
        list: useTaskFailureCapsuleAdminListHook(),
        get: useTaskFailureCapsuleAdminGetHook(),
        delete: useTaskFailureCapsuleAdminDeleteHook(),
        status: useTaskFailureCapsuleAdminStatusHook(),
        capture: useTaskFailureCapsuleAdminCaptureHook(),
        download: useTaskFailureCapsuleAdminDownloadHook(),
    },
    tenant: {
        getTenant: useTenantGetTenantHook(),
        getSettings: useTenantGetSettingsHook(),
        updateSettings: useTenantUpdateSettingsHook(),
        getMembers: useTenantGetMembersHook(),
        addMember: useTenantAddMemberHook(),
        removeMember: useTenantRemoveMemberHook(),
        updateMemberRole: useTenantUpdateMemberRoleHook(),
        leaveTenant: useTenantLeaveTenantHook(),
    },
    tenantAdmin: {
        getAllTenants: useTenantAdminGetAllTenantsHook(),
        createTenant: useTenantAdminCreateTenantHook(),
        getTenant: useTenantAdminGetTenantHook(),
        updateTenant: useTenantAdminUpdateTenantHook(),
        deleteTenant: useTenantAdminDeleteTenantHook(),
        getTenantSettings: useTenantAdminGetTenantSettingsHook(),
        updateTenantSettings: useTenantAdminUpdateTenantSettingsHook(),
        getMembers: useTenantAdminGetMembersHook(),
        addMember: useTenantAdminAddMemberHook(),
        removeMember: useTenantAdminRemoveMemberHook(),
        updateMemberRole: useTenantAdminUpdateMemberRoleHook(),
    },
    tenantCreate: {
        createTenant: useTenantCreateCreateTenantHook(),
    },
    user: {
        login: useUserLoginHook(),
        mySession: useUserMySessionHook(),
        register: useUserRegisterHook(),
        changePassword: useUserChangePasswordHook(),
        update: useUserUpdateHook(),
        getUser: useUserGetUserHook(),
        logout: useUserLogoutHook(),
        users: useUserUsersHook(),
        sessionsGet1: useUserSessionsGet1Hook(),
        logoutUserGlobal: useUserLogoutUserGlobalHook(),
        getUserIdFromUUID: useUserGetUserIdFromUUIDHook(),
        chatLogsPost: useUserChatLogsPostHook(),
        chatLogsGet: useUserChatLogsGetHook(),
        auditLog: useUserAuditLogHook(),
        getGrantsForUser: useUserGetGrantsForUserHook(),
        grantClient: useUserGrantClientHook(),
        revokeGrant: useUserRevokeGrantHook(),
        getMyTenant: useUserGetMyTenantHook(),
        getUserById: useUserGetUserByIdHook(),
        delete: useUserDeleteHook(),
        changePasswordAdmin: useUserChangePasswordAdminHook(),
        sessionsGet2: useUserSessionsGet2Hook(),
        session: useUserSessionHook(),
        auditLogAdmin: useUserAuditLogAdminHook(),
        enabledClassesPost: useUserEnabledClassesPostHook(),
        enabledClassesGet: useUserEnabledClassesGetHook(),
        regenerateAddonKey: useUserRegenerateAddonKeyHook(),
        switchAllClasses: useUserSwitchAllClassesHook(),
    },
    vektorAdmin: {
        listPossessions: useVektorAdminListPossessionsHook(),
        possessionStats: useVektorAdminPossessionStatsHook(),
        kick: useVektorAdminKickHook(),
        startDiagnostics: useVektorAdminStartDiagnosticsHook(),
        stopDiagnostics: useVektorAdminStopDiagnosticsHook(),
        diagnosticsStatus: useVektorAdminDiagnosticsStatusHook(),
        exportDiagnostics: useVektorAdminExportDiagnosticsHook(),
        startMonitor: useVektorAdminStartMonitorHook(),
        stopMonitor: useVektorAdminStopMonitorHook(),
        listMonitors: useVektorAdminListMonitorsHook(),
        listMonitorableBots: useVektorAdminListMonitorableBotsHook(),
        exportMonitor: useVektorAdminExportMonitorHook(),
    },
    vektorGoggles: {
        handshake: useVektorGogglesHandshakeHook(),
        handshakeDev: useVektorGogglesHandshakeDevHook(),
        me: useVektorGogglesMeHook(),
        listBots: useVektorGogglesListBotsHook(),
        listOverlays: useVektorGogglesListOverlaysHook(),
        streamOverlays: useVektorGogglesStreamOverlaysHook(),
        kickPossessor: useVektorGogglesKickPossessorHook(),
        listStorageChestIndex: useVektorGogglesListStorageChestIndexHook(),
        listStorageChestContents: useVektorGogglesListStorageChestContentsHook(),
        recordObservedChest: useVektorGogglesRecordObservedChestHook(),
        submitSchematic: useVektorGogglesSubmitSchematicHook(),
        listSchematics: useVektorGogglesListSchematicsHook(),
    },
    vektorUtils: {
        info: useVektorUtilsInfoHook(),
        download: useVektorUtilsDownloadHook(),
    },
    villageObservation: {
        getMine: useVillageObservationGetMineHook(),
        deleteAllMine: useVillageObservationDeleteAllMineHook(),
        getRuns: useVillageObservationGetRunsHook(),
        export: useVillageObservationExportHook(),
    },
    villagerTrading: {
        getVillagerHalls: useVillagerTradingGetVillagerHallsHook(),
        createVillagerHall: useVillagerTradingCreateVillagerHallHook(),
        getHallVillagers: useVillagerTradingGetHallVillagersHook(),
        updateVillagerHall: useVillagerTradingUpdateVillagerHallHook(),
        deleteVillagerHall: useVillagerTradingDeleteVillagerHallHook(),
        scanVillagerHall: useVillagerTradingScanVillagerHallHook(),
        createVillagerTradeConfig: useVillagerTradingCreateVillagerTradeConfigHook(),
        updateVillagerTradeConfig: useVillagerTradingUpdateVillagerTradeConfigHook(),
        deleteVillagerTradeConfig: useVillagerTradingDeleteVillagerTradeConfigHook(),
        runVillagerTradeConfig: useVillagerTradingRunVillagerTradeConfigHook(),
        stopVillagerTrading: useVillagerTradingStopVillagerTradingHook(),
    },
    voting: {
        getSites: useVotingGetSitesHook(),
        getState: useVotingGetStateHook(),
        getLog: useVotingGetLogHook(),
        availability: useVotingAvailabilityHook(),
        myAdHoc: useVotingMyAdHocHook(),
        createMyAdHoc: useVotingCreateMyAdHocHook(),
        deleteMyAdHocByUsername: useVotingDeleteMyAdHocByUsernameHook(),
        run: useVotingRunHook(),
        preview: useVotingPreviewHook(),
        schedulerStatus: useVotingSchedulerStatusHook(),
        adHocList: useVotingAdHocListHook(),
        adHocCreate: useVotingAdHocCreateHook(),
        adHocDelete: useVotingAdHocDeleteHook(),
        adHocSetEnabled: useVotingAdHocSetEnabledHook(),
        runTick: useVotingRunTickHook(),
        adminToday: useVotingAdminTodayHook(),
        adminStats: useVotingAdminStatsHook(),
        adminLog: useVotingAdminLogHook(),
        adminResetFailures: useVotingAdminResetFailuresHook(),
        setSiteEnabled: useVotingSetSiteEnabledHook(),
        adminClearStale: useVotingAdminClearStaleHook(),
        adminProxies: useVotingAdminProxiesHook(),
        adminProxySync: useVotingAdminProxySyncHook(),
        adminProxyReplace: useVotingAdminProxyReplaceHook(),
        adminForceStale: useVotingAdminForceStaleHook(),
    },
    wallE: {
        pushBotState: useWallEPushBotStateHook(),
    },
    webhook: {
        list: useWebhookListHook(),
        create: useWebhookCreateHook(),
        get: useWebhookGetHook(),
        update: useWebhookUpdateHook(),
        delete: useWebhookDeleteHook(),
        sendTest: useWebhookSendTestHook(),
    },
    xdsm: {
        getWeihnachten: useXDSMGetWeihnachtenHook(),
    },
    };
}
